import React from 'react';
import { FGInput, FGIcons } from '@fg/design-system';

type Props = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    id?: string;
    autoFocus?: boolean;
};

const RiskPickerSearch = React.memo((props: Props) => {
    const {
        value,
        onChange,
        placeholder = 'Search risk',
        id = 'risk-picker-search-input',
        autoFocus = false,
    } = props;
    return (
        <FGInput
            id={id}
            className="new-risk-picker-search-input"
            value={value}
            onChange={e => onChange(e.target.value)}
            onKeyDown={e => e.stopPropagation()}
            size="l"
            autoComplete="off"
            autoFocus={autoFocus}
            placeholder={placeholder}
            leftElement={<FGIcons icon="Search" size={12} />}
        />
    );
});

export default RiskPickerSearch;
